import { boot } from 'quasar/wrappers'
import * as LottiePlayer from '@lottiefiles/lottie-player'

export default boot(async ({ app }) => {
	app.component(LottiePlayer)
})
